// ─── INKY TEXTILES QUOTE CALCULATOR ────────────────────────────────────────────

// ─── BRAND PRICING ───────────────────────────────────────────────────────────
// S&S Activewear public pricing × 1.60 (60% markup covers cost + shipping).
// Gildan 5000 Heavy Cotton Tee: $6.22 × 1.6 = $9.95
// Bella+Canvas 3001 Unisex Jersey Tee: $8.98 × 1.6 = $14.37
// Inky Textiles Brand (Premium): fixed internal rate.
const BRAND_PRICES = {
  'gildan':      9.95,
  'bellacanvas': 14.37,
  'inky':        9.00,
};

// ─── PROMO CODES ─────────────────────────────────────────────────────────────
// Values are decimal discounts: 0.10 = 10% off. Add/remove codes here.
const PROMO_CODES = {
  'INKY10':  0.10,
  'GROUP15': 0.15,
  'WELCOME': 0.10,
};

function getZipShipping(z) {
  if (!z || z.length < 5) return null;
  const d = parseInt(z[0]);
  if (d <= 3) return '$8\u2013$14'; if (d <= 5) return '$6\u2013$11';
  if (d <= 7) return '$7\u2013$13'; return '$9\u2013$16';
}

function togglePlacement(loc) {
  const chk = document.getElementById('chk-' + loc);
  const block = document.getElementById('pb-' + loc);
  const sizes = document.getElementById(loc + '-sizes');
  const presets = document.getElementById(loc + '-presets');
  if (!chk || !block) return;
  if (chk.checked) { block.style.opacity = '1'; if (sizes) sizes.style.display = 'grid'; if (presets) presets.style.display = 'flex'; }
  else { block.style.opacity = '.45'; if (sizes) sizes.style.display = 'none'; if (presets) presets.style.display = 'none'; }
  calcPrice();
}

function setSize(loc, w, h) {
  const wEl = document.getElementById(loc + '-w'); const hEl = document.getElementById(loc + '-h');
  if (wEl) wEl.value = w; if (hEl) hEl.value = h; calcPrice();
}

function updateQty(val) {
  const d = document.getElementById('qty-display');
  if (d) d.textContent = parseInt(val).toLocaleString() + ' pieces';
}

function calcPrice() {
  const brandEl = document.getElementById('brand');
  const qtyEl = document.getElementById('qty');
  const zipEl = document.getElementById('zipcode');
  const promoEl = document.getElementById('promo-code');
  if (!qtyEl) return;

  const brandKey = brandEl ? brandEl.value : 'gildan';
  const base = BRAND_PRICES[brandKey] || 9.95;
  const qty = parseInt(qtyEl.value);
  const zip = zipEl ? zipEl.value : '';
  const promo = promoEl ? promoEl.value.trim().toUpperCase() : '';

  // Screen printing cost model
  const colorsEl = document.getElementById('colors');
  const colors = colorsEl ? parseFloat(colorsEl.value) : 3;
  const nP = (document.getElementById('chk-front')?.checked ? 1 : 0) +
             (document.getElementById('chk-back')?.checked ? 1 : 0) +
             (document.getElementById('chk-sleeve')?.checked ? 1 : 0) +
             (document.getElementById('chk-leftchest')?.checked ? 1 : 0) +
             (document.getElementById('chk-rightchest')?.checked ? 1 : 0);
  const setup = (3 + colors) * nP * 15;
  const ink = (0.5 + colors * 0.3) * nP;
  const printCost = setup + (ink * qty);
  const disc = qty >= 200 ? .70 : qty >= 100 ? .78 : qty >= 72 ? .84 : qty >= 48 ? .89 : qty >= 24 ? .94 : 1;
  let subtotal = base * disc * qty + printCost;

  // Promo code
  const promoValid = promo.length > 0 && PROMO_CODES[promo] !== undefined;
  let promoDiscount = 0;
  if (promoValid) {
    promoDiscount = subtotal * PROMO_CODES[promo];
    subtotal -= promoDiscount;
  }

  // Promo display
  const promoDisplay = document.getElementById('promo-display');
  const promoNote = document.getElementById('promo-note-text');
  if (promoDisplay) {
    if (!promo) {
      promoDisplay.textContent = 'Enter a promo code for a discount';
      promoDisplay.style.color = 'var(--gray)';
      if (promoNote) promoNote.textContent = 'Discount will be reflected in your quote total';
    } else if (promoValid) {
      const pct = Math.round(PROMO_CODES[promo] * 100);
      promoDisplay.textContent = pct + '% off applied \u2014 saving $' + promoDiscount.toFixed(2);
      promoDisplay.style.color = 'var(--egypt)';
      if (promoNote) promoNote.textContent = 'Code "' + promo + '" is valid \u00b7 discount included in total below';
    } else {
      promoDisplay.textContent = 'Code not recognized \u2014 double-check and try again';
      promoDisplay.style.color = '#e05252';
      if (promoNote) promoNote.textContent = '';
    }
  }

  // Shipping display
  const ship = getZipShipping(zip);
  const sd = document.getElementById('shipping-display');
  const zn = document.getElementById('zip-note');
  if (sd) {
    if (ship) { sd.textContent = ship + ' est.'; sd.style.color = 'var(--egypt)'; if (zn) zn.textContent = 'Shipping to zip ' + zip + ' \u2014 final rate at checkout'; }
    else { sd.textContent = 'Enter zip code for shipping estimate'; sd.style.color = 'var(--gray)'; if (zn) zn.textContent = 'Enter your zip code for an accurate shipping estimate'; }
  }

  const unit = qty > 0 ? subtotal / qty : 0;
  const total = Math.round(subtotal);
  const upEl = document.getElementById('unit-price'); const tpEl = document.getElementById('total-price');
  if (upEl) upEl.textContent = '$' + unit.toFixed(2);
  if (tpEl) tpEl.textContent = '$' + total.toLocaleString();

  const pls = [];
  if (document.getElementById('chk-front')?.checked) { const w = document.getElementById('front-w')?.value; const h = document.getElementById('front-h')?.value; if (w && h) pls.push('front ' + w + '\u00d7' + h + '"'); }
  if (document.getElementById('chk-back')?.checked) { const w = document.getElementById('back-w')?.value; const h = document.getElementById('back-h')?.value; if (w && h) pls.push('back ' + w + '\u00d7' + h + '"'); }
  if (document.getElementById('chk-sleeve')?.checked) { const w = document.getElementById('sleeve-w')?.value; const h = document.getElementById('sleeve-h')?.value; if (w && h) pls.push('sleeve ' + w + '\u00d7' + h + '"'); }
  if (document.getElementById('chk-leftchest')?.checked) { const w = document.getElementById('leftchest-w')?.value; const h = document.getElementById('leftchest-h')?.value; if (w && h) pls.push('L.chest ' + w + '\u00d7' + h + '"'); }
  if (document.getElementById('chk-rightchest')?.checked) { const w = document.getElementById('rightchest-w')?.value; const h = document.getElementById('rightchest-h')?.value; if (w && h) pls.push('R.chest ' + w + '\u00d7' + h + '"'); }

  const bd = document.getElementById('price-breakdown');
  if (bd) bd.textContent = qty + ' pcs \u00b7 ' + (pls.length ? pls.join(' \u00b7 ') : 'no placements') + (ship ? ' \u00b7 ship ' + ship : ' \u00b7 + shipping') + (promoValid ? ' \u00b7 ' + Math.round(PROMO_CODES[promo] * 100) + '% off' : '');
}

document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('qty')) { updateQty(48); calcPrice(); }
});
